export enum PAYMENT_GATEWAY_MODEL {
  IPG = 0,
  DPG = 1,
  USSD = 2,
  WALLET = 3,
  CPG = 4,
  DIRECT_DEBIT = 5,
  LIABILITY = 6,
  ISPG = 7,
  ICP = 8,
  POS = 9,
}
